var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    staticClass: "info-data",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    }
  }, [_vm.fixedField.customer ? _c('div', [_c('h4', [_vm._v("客户")]), _c('h2', {
    staticStyle: {
      "margin": "4px 0 12px 0"
    }
  }, [_vm._v(_vm._s(_vm.fixedField.customer.name))])]) : _vm._e(), _c('FormItem', {
    attrs: {
      "label": "产品",
      "prop": "product"
    }
  }, [_c('div', [_vm._v(_vm._s(this.product.model) + " - " + _vm._s(this.product.name))])]), _c('FormItem', {
    attrs: {
      "label": "配方名字",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入配方名字..."
    },
    model: {
      value: _vm.formItem.name,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "name", $$v);
      },
      expression: "formItem.name"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "设为默认生产配方",
      "prop": "usedInProd"
    }
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: _vm.formItem.usedInProd,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "usedInProd", $$v);
      },
      expression: "formItem.usedInProd"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1), _c('FormItem', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入备注...",
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      }
    },
    model: {
      value: _vm.formItem.remark,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "remark", $$v);
      },
      expression: "formItem.remark"
    }
  })], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")]), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('closeDrawer');
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _c('div', {
    staticClass: "material-data"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.displayData,
      "border": "",
      "show-summary": "",
      "summary-method": _vm.handleSummary
    },
    scopedSlots: _vm._u([{
      key: "ratio",
      fn: function (_ref) {
        var row = _ref.row,
          index = _ref.index;
        return [row.name !== '水' ? _c('div', [_c('InputNumber', {
          staticClass: "input-ratio",
          attrs: {
            "max": 100,
            "min": 0,
            "step": 0.1
          },
          model: {
            value: _vm.recipeList[index].ratio,
            callback: function ($$v) {
              _vm.$set(_vm.recipeList[index], "ratio", $$v);
            },
            expression: "recipeList[index].ratio"
          }
        }), _c('span', {
          staticClass: "percentage-append"
        }, [_vm._v("%")])], 1) : _c('span', [_vm._v(_vm._s(row.ratio) + "%")])];
      }
    }, {
      key: "deleteBtn",
      fn: function (_ref2) {
        var row = _ref2.row;
        return [row.name !== '水' ? _c('Icon', {
          staticClass: "deleteBtn",
          attrs: {
            "type": "ios-remove-circle-outline"
          },
          on: {
            "click": function ($event) {
              return _vm.removeMaterialfromRecipe(row._id);
            }
          }
        }) : _vm._e()];
      }
    }])
  })], 1), _c('div', {
    staticClass: "material-list-block"
  }, [_c('Input', {
    staticStyle: {
      "margin": "0 4px"
    },
    attrs: {
      "search": "",
      "clearable": "",
      "placeholder": "搜索原材料..."
    },
    on: {
      "on-change": _vm.searchMaterial
    },
    model: {
      value: _vm.searchMaterialText,
      callback: function ($$v) {
        _vm.searchMaterialText = $$v;
      },
      expression: "searchMaterialText"
    }
  }), _c('Divider', {
    attrs: {
      "orientation": "left"
    }
  }, [_vm._v("母液")]), _c('div', {
    staticClass: "material-list"
  }, _vm._l(_vm.filteredMaterialList.filter(function (x) {
    return x.type === 'semi';
  }), function (i) {
    return _c('div', {
      key: i._id,
      class: {
        'm-cell': true,
        selected: _vm.displayData.map(function (e) {
          return e._id;
        }).indexOf(i._id) !== -1
      },
      on: {
        "click": function ($event) {
          return _vm.addToRecipe(i);
        }
      }
    }, [_vm._v(" " + _vm._s(i.model) + " " + _vm._s(i.name) + " ")]);
  }), 0), _c('Divider', {
    attrs: {
      "orientation": "left"
    }
  }, [_vm._v("原材料")]), _c('div', {
    staticClass: "material-list"
  }, _vm._l(_vm.filteredMaterialList.filter(function (x) {
    return x.type === 'raw' && x.usedForProduct === true;
  }), function (i) {
    return _c('div', {
      key: i._id,
      class: {
        'm-cell': true,
        selected: _vm.displayData.map(function (e) {
          return e._id;
        }).indexOf(i._id) !== -1
      },
      on: {
        "click": function ($event) {
          return _vm.addToRecipe(i);
        }
      }
    }, [_vm._v(" " + _vm._s(i.name) + " ")]);
  }), 0)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }